import { fs93ConsumerOpenConversations } from "../firestore_schemas/fs93ConsumerOpenConversations"
import { removeDocFrom_fs93ConsumerOpenConversations } from "../firestore_schemas/fs93ConsumerOpenConversations"

type Result = {
  debug_data: Array<string>;
  return_msg: string;
  success: boolean;
  error_title: string;
  error_summary: string;
  error_next_steps: string;
};

export async function fs93Writer(
  w_type: string,
  fs1_uid: string,
  fs2_uid: string,
  fs78_uid: string,
  fs93_uid: string,
  data: any
) {

  const retval: Result = {
    debug_data: [],
    return_msg: "fs93_writer:fs93Writer ",
    success: true,
    error_title: "",
    error_summary: "",
    error_next_steps: "",
  };

  /// Validate arguments according to write type
  if (!fs1_uid || !fs2_uid || !fs78_uid) {
    retval.success = false;
    retval.return_msg += "Insufficient arguments.";
    retval.error_title = "Insufficient arguments.";
    retval.error_summary = "uids not set.";
    retval.error_next_steps = "Please provide correct uids.";
    return retval;
  }
  /// <END> Validate arguments according to write type

  // Remove
  if (w_type == "d") {
    await removeDocFrom_fs93ConsumerOpenConversations(fs1_uid, fs2_uid, fs78_uid, fs93_uid);
    return retval
  }

}

function firestoreWriteError(error:any) {
  // TODO - complete this
}
